import { Manager } from "socket.io-client";
import { eventEmitter } from "utils/eventEmitter";

const connectToRealTime = (realTimeConfig = {}) => {
  if (realTimeConfig) {
    // const { url, token, nameSpace } = realTimeConfig;
    const manager = new Manager(realTimeConfig.url, {
      reconnectionDelayMax: 20000,
    });

    const socket = manager.socket(realTimeConfig.nameSpace, {
      auth: {
        token: realTimeConfig.token,
      },
    });

    socket.once("connect", () => {
      console.log(`socket ${socket.id} connected`);

      // saveSocket(socket);
    });

    socket.on("connect_error", (error) => {
      console.log(`socket ${socket.id} connection error ${error.message}`);
      setTimeout(() => {
        socket.connect();
      }, 3000);
    });

    socket.on("message", (msg) => {
      eventEmitter.emit(msg.event, msg.data);
    });

    socket.on("disconnect", (reason) => {
      console.log(`socket disconnected due to ${reason}`);
      eventEmitter.unSubscribe("hardReloadClient", true);
    });
  }
};

export default connectToRealTime;
